import { useMemo } from "react";
import { IOption } from "../../../../../../../../../../types/Option";

export const useFormattedOptions = (
  data: any,
  idName: string,
  name: string = "payerName"
) => {
  const options: IOption[] = useMemo(() => {
    const payerIdsSet: Set<string> = new Set(
      data.map((item: any) => item[idName])
    );

    const payerIds: string[] = Array.from(payerIdsSet);

    const payers: any[] = payerIds
      .map((id: string) => data.find((item: any) => item[idName] === id))
      .filter((item: any | undefined) => !!item);

    return payers.map((item: any) => ({
      value: item[idName],
      label: item[name],
    }));
  }, [data, idName, name]);

  return { options };
};
